import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { inOutAnimation } from "../../common/animations";
import { CalculatorResultWrapper } from '../../common/models/analysis/calculator-result-wrapper';
import { AuthService } from '../../services/auth/auth.service';
import { Router } from '@angular/router';
import { UserRole } from '../../common/models/user/user-role.enum';
import { PageTitleService } from '../../services/page-title.service';
import { ClientType } from 'src/common/models/client/client-type-enum';
import { ClientInfo } from 'src/common/models/client/client-info';

@Component({
  selector: 'psc-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  animations: [inOutAnimation({})],
})
export class HomeComponent implements OnInit {
  clientTypes: ClientType[] = Object.values(ClientType);
  selectedClientType: ClientType = ClientType.ALL;

  private readonly collaboratorsAssetsUrl = 'assets/images/collaborators/';
  collaborators: { [key: string]: ClientInfo[] } = {
    [ClientType.FINANCIAL]: [{
      url: 'https://www.procreditbank.rs/',
      logo: `${ this.collaboratorsAssetsUrl }pro-credit-bank-logo.png`,
    }],
    [ClientType.INSTALLER]: [{
      url: 'https://www.elmex.ba/',
      logo: `${ this.collaboratorsAssetsUrl }elmex-logo.png`,
    }],
    [ClientType.PARTNER]: [
      {
        url: 'https://www.inka.ba/',
        logo: `${ this.collaboratorsAssetsUrl }inka-logo.png`,
        text: '300 kW',
      },
    ],
  };

  get selectedClientTypes(): ClientInfo[] {
    if (this.selectedClientType === ClientType.ALL) {
      return Object.values(this.collaborators).flat();
    }
    return this.collaborators[this.selectedClientType];
  }

  calculatorResultWrapper: CalculatorResultWrapper;
  @ViewChild('solarCalculatorResult') solarCalculatorResultElement: ElementRef;

  constructor(
    private authService: AuthService,
    private router: Router,
    private pageTitleService: PageTitleService,
  ) {
    /**
     * t(title.home)
     */
    this.pageTitleService.setTitle('title.home');
  }

  ngOnInit(): void {
    if (this.authService.userLoggedIn() &&
      this.authService.userHasRoles([
        UserRole.ROLE_PERSONAL,
        UserRole.ROLE_BUSINESS_PLUS,
        UserRole.ROLE_BUSINESS,
        UserRole.ROLE_BUSINESS_EXP,
        UserRole.ROLE_BUSINESS_PLUS_EXP,
      ])) {
      this.router.navigate(['/customer']);
    }

    if (this.authService.userLoggedIn() &&
      this.authService.userHasRoles([
        UserRole.ROLE_ADMIN,
      ])) {
      this.router.navigate(['/admin']);
    }
  }

  clientChange(clientType: ClientType) {
    this.selectedClientType = clientType;
  }

  protected readonly UserRole = UserRole;
}
